module.exports = __webpack_public_path__ + "img/partners-id__for_dark_bg.4730b80.png";